import { render, staticRenderFns } from "./modalAxessEventSetup.vue?vue&type=template&id=807f8146&"
import script from "./modalAxessEventSetup.vue?vue&type=script&lang=js&"
export * from "./modalAxessEventSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports